import axios, { InternalAxiosRequestConfig } from "axios";
import { t } from "i18next";
import { enqueueSnackbar } from "notistack";

const call = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

call.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem("cih_token");
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

call.interceptors.response.use(
  (response) => {
    const config = response.config;
    const snack = config.snack;
    const statusCode = response.status;

    if (snack && statusCode && snack[statusCode] !== null) {
      const translationKey = snack[statusCode] || snack.success;

      if (translationKey) {
        const message = t(translationKey, { ns: "snack" });
        const uniqueKey = `snackbar-success-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
        enqueueSnackbar(message, { variant: "success", key: uniqueKey });
      }
    }

    return response;
  },
  (error) => {
    const config = error.config;
    const snack = config?.snack;
    const statusCode = error.response?.status;

    if (snack && statusCode && snack[statusCode] !== null) {
      const translationKey = snack[statusCode] || snack.error;

      if (translationKey) {
        const message = t(translationKey, { ns: "snack" });
        const uniqueKey = `snackbar-error-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
        enqueueSnackbar(message, { variant: "error", key: uniqueKey });
      }
    }

    return Promise.reject(error);
  }
);

export default call;
